import React, { useRef, useState } from 'react';

const FamilyHistoryForm: React.FC = () => {
  const [children, setChildren] = useState<Array<{ id: number }>>([{ id: 1 }]);
  const addChild = () => setChildren(prev => [...prev, { id: prev.length + 1 }]);
  const removeChild = (index: number) => setChildren(prev => prev.filter((_, i) => i !== index));
  const formRef = useRef<HTMLFormElement>(null);
  const handleClear = () => formRef.current?.reset();

  return (
    <form ref={formRef} className="family-form">
      <div className="section-title">Parent 1</div>
      <div className="form-grid">
        <div className="field col-span-2">
          <label>Past Health Problems</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Age</label>
          <input type="number" />
        </div>
        <div className="field">
          <label>Current Health</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Ethnicity</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Education / Training</label>
          <input type="text" />
        </div>
      </div>

      <div className="section-title">Parent 2</div>
      <div className="form-grid">
        <div className="field col-span-2">
          <label>Past Health Problems</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Age</label>
          <input type="number" />
        </div>
        <div className="field">
          <label>Current Health</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Ethnicity</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Education / Training</label>
          <input type="text" />
        </div>
      </div>

      <div className="section-title">Marital Status</div>
      <div className="form-grid">
        <div className="field col-span-2">
          <input type="text" />
        </div>
      </div>

      <div className="section-title">Other Children in Family</div>
      {children.map((c, idxChild) => (
        <div key={c.id} className="child-card">
          <div className="child-header">Child {idxChild + 1} <button className="icon-btn" title="Remove" onClick={() => removeChild(idxChild)}>🗑️</button></div>
          <div className="form-grid">
            <div className="field">
              <label>Name</label>
              <input type="text" />
            </div>
            <div className="field">
              <label>Date of Birth</label>
              <input type="date" />
            </div>
            <div className="field">
              <label>Gender</label>
              <input type="text" />
            </div>
            <div className="field col-span-2">
              <label>Health or Medical Issues</label>
              <input type="text" />
            </div>
          </div>
        </div>
      ))}
      <button className="btn-add" onClick={addChild}>+ Add child</button>

      <div className="section-title">Family History (Yes / No)</div>
      {(() => {
        const beforeCancer = ['Allergies','Anxiety','Asthma','Birth Defects / Genetic Problems'];
        const afterCancer = ['Depression','Diabetes','Hearing Loss','Heart Attack','Heart Disease','Hepatitis','High Blood Pressure','High Cholesterol','Learning Disability','Mental Illness','Seizures','Thyroid Problems','Tuberculosis'];
        const leftAfter = afterCancer.slice(0, 2); // 6..7
        const rightAfter = afterCancer.slice(2);   // 8..18
        const renderItem = (label: string, number: number) => (
          <div key={label} className="yesno-item">
            <span className="lbl">{number}. {label}</span>
            <label><input type="radio" name={`item-${number}`} /> Yes</label>
            <label><input type="radio" name={`item-${number}`} /> No</label>
          </div>
        );
        return (
          <div className="yesno-cols">
            <div className="yesno-col">
              {beforeCancer.map((it, i) => renderItem(it, i + 1))}
              <div className="yesno-item lbl-strong">5. Cancer</div>
              {['Brain','Breast','Colon','Ovarian','Skin','Thyroid','Other'].map((it, idx) => (
                <div key={it} className="yesno-item sub cancer-sub">
                  <span className="lbl">{it}</span>
                  <label><input type="radio" name={`cancer-${idx}`} /> Yes</label>
                  <label><input type="radio" name={`cancer-${idx}`} /> No</label>
                </div>
              ))}
              {leftAfter.map((it, i) => renderItem(it, i + 6))}
            </div>
            <div className="yesno-col">
              {rightAfter.map((it, i) => renderItem(it, i + 8))}
            </div>
          </div>
        );
      })()}
      <div className="form-actions">
        <button type="button" className="btn-clear" onClick={handleClear}>Clear</button>
      </div>
    </form>
  );
};

export default FamilyHistoryForm;


